
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';

moment.locale('it');

@Component
export default class TimeoutButton extends Vue {
  @Prop(Number) readonly value!: number
  @Prop({ type: String, default: 'Ok' }) readonly title!: string
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
  @Prop({ type: Number, default: 0 }) readonly count!: number

  timeout = 0
  interval: number | undefined = undefined

  created() {
    console.log('TimeoutButton: created()'); // eslint-disable-line no-console

    // Se è già presente un valore di partenza,
    // inizia col conto alla rovescia.
    if (this.value && this.value > 0) this.startCountdown();
  }

  @Watch('value')
  onValueChange(val: number, oldVal: number) {
    console.log('TimeoutButton: onValueChange() val =', val); // eslint-disable-line no-console

    if (val === 0 && this.disabled) {
      // Se è in corso un altro countdown lo ferma (per poi riprenderlo)
      if (this.interval) clearInterval(this.interval);

      this.timeout = 0;
    } else

    if (val && val > 0) this.startCountdown();
  }

  @Watch('count')
  onCountChange(val: number, oldVal: number) {
    console.log('TimeoutButton: onCountChange() val =', val); // eslint-disable-line no-console

    if (this.value && this.value > 0) this.startCountdown();
  }

  get progressValue(): number {
    return this.value ? (100 / this.value) * this.timeout : 100;
  }

  startCountdown() {
    console.log('TimeoutButton: startCountdown() this.value =', this.value); // eslint-disable-line no-console
    console.log('TimeoutButton: startCountdown() this.timeout =', this.timeout); // eslint-disable-line no-console

    // Se non è impostato un valore di partenza, esce.
    if (!this.value || this.value < 0) return;

    // Se è in corso un altro countdown lo ferma (per poi riprenderlo)
    if (this.interval) clearInterval(this.interval);

    // Imposta il contatore al valore iniziale
    this.timeout = this.value;

    this.interval = setInterval(() => {
      if (this.timeout === 0) {
        this.onTimeout();
      }
      this.timeout -= 1;
    }, 1000);
  }

  onClick() {
    console.log('TimeoutButton: onClick()'); // eslint-disable-line no-console

    // console.log('TimeoutButton: onClick() disattivo il timer'); // eslint-disable-line no-console
    if (this.interval) clearInterval(this.interval);

    this.$emit('click');
  }

  onTimeout() {
    console.log('TimeoutButton: onTimeout()'); // eslint-disable-line no-console

    if (this.interval) clearInterval(this.interval);

    this.$emit('timeout');
  }

  beforeDestroy() {
    console.log('TimeoutButton: beforeDestroy()'); // eslint-disable-line no-console

    clearInterval(this.interval);
  }
}
